"use client"

import React from "react"
import Swal from "sweetalert2"
import authAxios from "../../services/Token"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { 
  faInfo, 
  faSave, 
  faUser, 
  faFolder, 
  faPrint, 
  faBook, 
  faGraduationCap, 
  faCalendar,
  faFilePdf,
  faFileVideo,
  faFileImage,
  faFile,
  faTasks,
  faChevronDown,
  faChevronUp,
  faQuestionCircle,
  faList,
  faCheckSquare,
  faKeyboard,
  faPaperPlane,
  faDownload,
  faPlay,
  faTimes,
  faCertificate,
  faMap,
  faEye,
  faComments,
  faUpload,
  faClock,
  faBuilding,
  faBars,
  faCheckCircle,
  faCircle
} from "@fortawesome/free-solid-svg-icons"
import { apiImage } from "../../services/Api"
import './Certificado.css';

const fechaactual = new Date().toLocaleString().split(",")
const f = fechaactual[0].split("/")
const hoy = f[2].padStart(2, "0") + "-" + f[1].padStart(2, "0") + "-" + f[0].padStart(2, "0")
const fechaActual2 = new Date()
fechaActual2.setDate(fechaActual2.getDate() - 5)

const f2 = fechaActual2.toLocaleDateString().split("/")
const haceDosDias = f2[2].padStart(2, "0") + "-" + f2[1].padStart(2, "0") + "-" + f2[0].padStart(2, "0")

class Listar extends React.Component {
  constructor(props) {
    super(props)
    this.toggleRespuestas = this.toggleRespuestas.bind(this)
    this.Enviar = this.Enviar.bind(this)
    this.handleCheckboxChangeFilter = this.handleCheckboxChangeFilter.bind(this)
    this.handleSelectAll = this.handleSelectAll.bind(this)
    this.VerContenidoCurso = this.VerContenidoCurso.bind(this)
    this.toggleClase = this.toggleClase.bind(this)
    this.VerEvaluacion = this.VerEvaluacion.bind(this)
    this.cerrarEvaluacion = this.cerrarEvaluacion.bind(this)
    this.handleRespuestaChange = this.handleRespuestaChange.bind(this)
    this.handleRespuestaMultipleChange = this.handleRespuestaMultipleChange.bind(this)
    this.handleRespuestaLibreChange = this.handleRespuestaLibreChange.bind(this)
    this.enviarEvaluacion = this.enviarEvaluacion.bind(this)
    this.abrirVideo = this.abrirVideo.bind(this)
    this.cerrarVideo = this.cerrarVideo.bind(this)
    this.abrirDocumento = this.abrirDocumento.bind(this)
    this.cerrarDocumento = this.cerrarDocumento.bind(this)
    this.descargarCertificado = this.descargarCertificado.bind(this)
    this.cerrarCertificado = this.cerrarCertificado.bind(this)
    this.navegarAClase = this.navegarAClase.bind(this)
    this.scrollToClase = this.scrollToClase.bind(this)
    this.imprimirCertificado = this.imprimirCertificado.bind(this)
    this.descargarComoPDF = this.descargarComoPDF.bind(this)
    this.abrirForo = this.abrirForo.bind(this)
    this.cerrarForo = this.cerrarForo.bind(this)
    this.handleComentarioChange = this.handleComentarioChange.bind(this)
    this.handleArchivoForoChange = this.handleArchivoForoChange.bind(this)
    this.enviarRespuestaForo = this.enviarRespuestaForo.bind(this)
    this.abrirDocumentoForo = this.abrirDocumentoForo.bind(this)
    this.cerrarDocumentoForo = this.cerrarDocumentoForo.bind(this)
    this.toggleMapaNavegacion = this.toggleMapaNavegacion.bind(this)
    this.marcarContenidoVisto = this.marcarContenidoVisto.bind(this)
  }
  
  state = {
    datosCargados: false,
    sinRegistrar: true,
    registrado: false,
    ListaTabla: [],
    ListaVehiculos: [],
    ListaConductor: [],
    selectedItems: [],
    forosClase: [], 
    selectAll: false,
    Hoy: hoy,
    haceDosDias: haceDosDias,
    cursoSeleccionado: null,
    clasesCurso: [],
    clasesAbiertas: {},
    evaluacionAbierta: false,
    preguntasEvaluacion: [],
    respuestasUsuario: {},
    evaluacionActual: null,
    videoAbierto: false,
    videoUrl: "",
    documentoAbierto: false,
    documentoUrl: "",
    documentoNombre: "",
    certificadoAbierto: false,
    certificadoData: null,
    claseActiva: null,
    foroAbierto: false,
    foroActual: null,
    respuestaForo: "",
    archivoForo: null,
    forosClase: [],
    respuestaExistente: null,
    documentoForoAbierto: false,
    documentoForoUrl: "",
    documentoForoNombre: "",
    documentoForoTipo: "",
    mapaNavegacionAbierto: false,
    contenidosVistos: {} // Nuevo estado para trackear contenidos vistos
  }

  // Función para marcar contenido como visto
  async marcarContenidoVisto(contenidoId, claseId) {
    try {
      const estudiante_id = localStorage.getItem("cliente_id")
      
      await authAxios.post('cursos/marcar-contenido-visto', {
        estudiante_id: estudiante_id,
        contenido_id: contenidoId,
        clase_id: claseId
      })

      // Actualizar estado local
      this.setState(prevState => ({
        contenidosVistos: {
          ...prevState.contenidosVistos,
          [contenidoId]: true
        }
      }))

    } catch (error) {
      console.error('Error al marcar contenido como visto:', error)
    }
  }

  // Función para alternar el mapa de navegación en móvil
  toggleMapaNavegacion() {
    this.setState(prevState => ({
      mapaNavegacionAbierto: !prevState.mapaNavegacionAbierto
    }))
  }

  // Función para navegar a una clase y cerrar el mapa en móvil
navegarAClase(claseId) {
  this.setState(prevState => ({
    clasesAbiertas: {
      ...prevState.clasesAbiertas,
      [claseId]: true
    },
    claseActiva: claseId,
    mapaNavegacionAbierto: false
  }), () => {
    setTimeout(() => {
      this.scrollToClase(claseId);
    }, 100);
  });
}

scrollToClase(claseId) {
  this.scrollToElement(`clase-${claseId}`);
}

  handleSelectAll(event) {
    const { ListaTabla, sinRegistrar, registrado } = this.state
    const isChecked = event.target.checked

    const filteredList = ListaTabla.filter((item) => {
      if (sinRegistrar && registrado) {
        return true
      } else if (sinRegistrar) {
        return item.estado !== "Registrado"
      } else if (registrado) {
        return item.estado === "Registrado"
      } else {
        return false
      }
    })

    if (isChecked) {
      this.setState({ selectedItems: filteredList, selectAll: true })
    } else {
      this.setState({ selectedItems: [], selectAll: false })
    }
  }

  handleCheckboxChangeFilter(event) {
    const target = event.target
    const name = target.name
    const checked = target.checked

    this.setState({
      [name]: checked,
    })
  }

  getFilteredList() {
    const { sinRegistrar, registrado, ListaTabla } = this.state
    return ListaTabla.filter((item) => {
      if (sinRegistrar && registrado) {
        return true
      } else if (sinRegistrar) {
        return item.estado !== "Registrado"
      } else if (registrado) {
        return item.estado === "Registrado"
      } else {
        return false
      }
    })
  }

  async VerContenidoCurso(cursoId) {
    try {
      Swal.showLoading()
      var estudiante_id = localStorage.getItem("cliente_id")
      const response = await authAxios.get(`cursos/clases/${cursoId}/${estudiante_id}`)
      Swal.close()
      
      // Inicializar contenidos vistos
      const contenidosVistos = {}
      response.data.forEach(clase => {
        clase.contenidos.forEach(contenido => {
          if (contenido.visto) {
            contenidosVistos[contenido.clase_contenido_id] = true
          }
        })
      })
      
      // Abrir la primera clase automáticamente
      const clasesAbiertas = {}
      if (response.data.length > 0) {
        clasesAbiertas[response.data[0].materia.ccc] = true
      }
      
      this.setState({ 
        cursoSeleccionado: cursoId,
        clasesCurso: response.data,
        clasesAbiertas: clasesAbiertas,
        claseActiva: response.data.length > 0 ? response.data[0].materia.ccc : null,
        contenidosVistos: contenidosVistos
      })
    } catch (error) {
      Swal.close()
      Swal.fire("Error", "No se pudo cargar el contenido del curso", "error")
    }
  }

  async VerEvaluacion(evaluacionId, claseTitulo, claseId) {
    try {
      Swal.showLoading()
      const response = await authAxios.get(`cursos/evaluacion/${evaluacionId}`)
      Swal.close()
      
      // Inicializar respuestas vacías
      const respuestasIniciales = {}
      response.data.forEach(pregunta => {
        if (pregunta.preguntas.tipo_pregunta === "SELECCION MULTIPLE") {
          respuestasIniciales[pregunta.preguntas.idp] = []
        } else {
          respuestasIniciales[pregunta.preguntas.idp] = ""
        }
      })
      
      this.setState({ 
        evaluacionAbierta: true,
        preguntasEvaluacion: response.data,
        respuestasUsuario: respuestasIniciales,
        evaluacionActual: { 
          id: evaluacionId, 
          titulo: claseTitulo,
          clase_id: claseId 
        }
      })
    } catch (error) {
      Swal.close()
      Swal.fire("Error", "No se pudo cargar la evaluación", "error")
    }
  }

  cerrarEvaluacion() {
    this.setState({ 
      evaluacionAbierta: false,
      preguntasEvaluacion: [],
      respuestasUsuario: {},
      evaluacionActual: null
    })
  }

  abrirVideo(urlVideo, contenidoId = null, claseId = null) {
    this.setState({
      videoAbierto: true,
      videoUrl: urlVideo
    })

    // Marcar como visto si se proporciona contenidoId y claseId
    if (contenidoId && claseId) {
      this.marcarContenidoVisto(contenidoId, claseId)
    }
  }

  cerrarVideo() {
    this.setState({
      videoAbierto: false,
      videoUrl: ""
    })
  }

  abrirDocumento(urlDocumento, nombreDocumento, contenidoId = null, claseId = null) {
    this.setState({
      documentoAbierto: true,
      documentoUrl: `${apiImage+urlDocumento}`,
      documentoNombre: nombreDocumento
    })

    // Marcar como visto si se proporciona contenidoId y claseId
    if (contenidoId && claseId) {
      this.marcarContenidoVisto(contenidoId, claseId)
    }
  }

  cerrarDocumento() {
    this.setState({
      documentoAbierto: false,
      documentoUrl: "",
      documentoNombre: ""
    })
  }

  async descargarCertificado(curso) {
    try {
        const estudiante_id = localStorage.getItem("cliente_id");
        
        Swal.showLoading();
        
        // Obtener datos del certificado
        const response = await authAxios.post('cursos/generar-certificado', {
            curso_id: curso.id,
            estudiante_id: estudiante_id
        });
        
        Swal.close();
        
        if (response.data.success) {
            // Mostrar el certificado en un modal con opción de imprimir/descargar
            this.setState({
                certificadoAbierto: true,
                certificadoData: response.data
            });
        } else {
            Swal.fire("Error", response.data.message, "error");
        }

    } catch (error) {
        Swal.close();
        Swal.fire("Error", "No se pudo generar el certificado", "error");
    }
  }
  async EnviarCertificado(curso) {
    try {
        const estudiante_id = localStorage.getItem("cliente_id");
        
        Swal.showLoading();
        
        // Obtener datos del certificado
        const response = await authAxios.post('cursos/generar-certificado-correo', {
            curso_id: curso.id,
            estudiante_id: estudiante_id
        });
        
        Swal.close();
        
        if (response.data.success) {
            // Mostrar el certificado en un modal con opción de imprimir/descargar
            alert("Se ha enviado el certificado a su correo.");
        } else {
            Swal.fire("Error", response.data.message, "error");
        }

    } catch (error) {
        Swal.close();
        Swal.fire("Error", "No se pudo generar el certificado", "error");
    }
  }

  imprimirCertificado() {
    window.print();
  }

descargarComoPDF() {
  const { certificadoData } = this.state;

  const ventana = window.open('', '_blank');
  ventana.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <title>Certificado - ${certificadoData.curso_nombre}</title>
      <style>
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body {
          font-family: 'Inter', sans-serif;
          background: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 100vh;
          padding: 10px;
        }
        .cert {
          width: 148mm;
          height: 210mm;
          background: #fff;
          border: 1px solid #dee2e6;
          border-radius: 8px;
          box-shadow: 0 2px 6px rgba(0,0,0,.1);
          padding: 10mm 7mm;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          font-size: 9px;
          line-height: 1.15;
        }
        .cert h1 { font-size: 16px; margin-bottom: 4px; }
        .cert h2 { font-size: 12px; margin-bottom: 3px; }
        .cert h3 { font-size: 10px; margin-bottom: 3px; }
        .cert p { margin-bottom: 2px; }
        .logo { max-height: 28px; margin-bottom: 4px; }
        .center { text-align: center; }
        .divider { width: 60px; height: 1px; background: #28a745; margin: 4px auto; }
        .border-top { border-top: 1px solid #000; width: 120px; margin: 4px auto; }
        @media print { @page { margin: 0; size: A5; } }
      </style>
    </head>
    <body>
      <div class="cert">
        <div class="center">
          <img src="https://documentos2024-aoa.s3.bhs.io.cloud.ovh.net/9999/Learning/logov2.png" class="logo" onerror="this.style.display='none'"/>
          <h1>CERTIFICADO</h1>
          <p>DE FINALIZACIÓN Y APROBACIÓN</p>
        
        </div>

        <div class="center">
          <p>La institución certifica que:</p>
          <h2>${certificadoData.estudiante_nombre_completo}</h2>
          <p>Ha completado satisfactoriamente el programa de formación:</p>
          <h3>"${certificadoData.curso_nombre}"</h3>
          <p>Código: ${certificadoData.curso_codigo}</p>
          <p><strong>Aprobado el ${certificadoData.fecha_emision}</strong></p>
          <p>8 Horas de teoría</p>
        </div>

        <div class="center">
          <p>Por su dedicación y excelencia académica.</p>
          <div class="border-top"></div>
          <p style="font-size: 8px;">Firma y Sello Institucional</p>
          <p style="font-size: 7px; margin-top: 6px;">
            Código: <strong>${certificadoData.codigo_certificado}</strong><br/>
            Válido según registros de ${certificadoData.empresa_nombre}
          </p>
        </div>
      </div>

      <script>window.print(); window.addEventListener('afterprint', () => window.close());</script>
    </body>
    </html>
  `);
  ventana.document.close();
}

  cerrarCertificado() {
    this.setState({
      certificadoAbierto: false,
      certificadoData: null
    });
  }

  toggleClase(claseId) {
    this.setState(prevState => ({
      clasesAbiertas: {
        ...prevState.clasesAbiertas,
        [claseId]: !prevState.clasesAbiertas[claseId]
      },
      claseActiva: claseId
    }))
  }


 async abrirForo(claseId, claseTitulo) {
  try {
    Swal.showLoading()
    const estudiante_id = localStorage.getItem("cliente_id")
    
    // Obtener foros de la clase
    const response = await authAxios.get(`cursos/foros/${claseId}/${estudiante_id}`)
    Swal.close()
    
    // Inicializar mostrarRespuestas para cada foro
    const forosConEstado = response.data.foros?.map(foro => ({
      ...foro,
      mostrarRespuestas: false // Inicialmente cerrado
    })) || []
    
    console.log('Foros cargados:', forosConEstado) // Para debug
    
    this.setState({ 
      foroAbierto: true,
      foroActual: { 
        claseId: claseId, 
        titulo: claseTitulo 
      },
      forosClase: forosConEstado,
      respuestaForo: "",
      archivoForo: null
    })
  } catch (error) {
    Swal.close()
    Swal.fire("Error", "No se pudo cargar el foro", "error")
  }
}

  // Agregar esta función para manejar la expansión/contracción de respuestas
  toggleRespuestas(foroId) {
    this.setState(prevState => ({
      forosClase: prevState.forosClase.map(foro => 
        foro.id === foroId 
          ? { ...foro, mostrarRespuestas: !foro.mostrarRespuestas }
          : foro
      )
    }))
  }

  abrirDocumentoForo(documentoUrl, documentoNombre) {
    const extension = documentoUrl.split('.').pop().toLowerCase()
    const esPDF = extension === 'pdf'
    const esImagen = ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)
    
    this.setState({
      documentoForoAbierto: true,
      documentoForoUrl: `${apiImage}${documentoUrl}`,
      documentoForoNombre: documentoNombre,
      documentoForoTipo: esPDF ? 'pdf' : esImagen ? 'imagen' : 'otro'
    })
  }

  cerrarDocumentoForo() {
    this.setState({
      documentoForoAbierto: false,
      documentoForoUrl: "",
      documentoForoNombre: "",
      documentoForoTipo: ""
    })
  }

  cerrarForo() {
    this.setState({ 
      foroAbierto: false,
      foroActual: null,
      forosClase: [],
      respuestaExistente: null,
      respuestaForo: "",
      archivoForo: null
    })
  }

  handleComentarioChange(event) {
    this.setState({ respuestaForo: event.target.value })
  }

  handleArchivoForoChange(event) {
    this.setState({ archivoForo: event.target.files[0] })
  }

  async enviarRespuestaForo() {
    const { foroActual, respuestaForo, archivoForo, respuestaExistente } = this.state
    const estudiante_id = localStorage.getItem("cliente_id")

    if (!respuestaForo.trim()) {
      Swal.fire("Atención", "Por favor escribe un comentario antes de enviar", "warning")
      return
    }

    // Validar si ya existe una respuesta
    if (respuestaExistente) {
      Swal.fire("Atención", "Ya has enviado una respuesta a este foro", "warning")
      return
    }

    try {
      Swal.showLoading()

      const formData = new FormData()
      formData.append('estudiante_id', estudiante_id)
      formData.append('clase_id', foroActual.claseId)
      formData.append('comentario', respuestaForo)
      
      if (archivoForo) {
        formData.append('documento_adjunto', archivoForo)
      }

      const response = await authAxios.post('cursos/guardar-respuesta-foro', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })

      Swal.close()
      
      if (response.data.success) {
        Swal.fire("¡Éxito!", "Respuesta enviada correctamente", "success")
        this.cerrarForo()
      } else {
        Swal.fire("Error", response.data.message, "error")
      }

    } catch (error) {
      Swal.close()
      Swal.fire("info", "Ya este foro esta cerrado", "error")
    }
  }

  getIconoPorTipo(archivo) {
    if (!archivo) return faFile
    
    const extension = archivo.split('.').pop().toLowerCase()
    if (['pdf'].includes(extension)) return faFilePdf
    if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)) return faFileImage
    if (['mp4', 'avi', 'mov', 'wmv'].includes(extension)) return faFileVideo
    return faFile
  }

  getIconoTipoPregunta(tipo) {
    switch(tipo) {
      case "UNICA RESPUESTA":
        return faList
      case "SELECCION MULTIPLE":
        return faCheckSquare
      case "RESPUESTA LIBRE":
        return faKeyboard
      default:
        return faQuestionCircle
    }
  }

  handleRespuestaChange(preguntaId, respuestaId) {
    this.setState(prevState => ({
      respuestasUsuario: {
        ...prevState.respuestasUsuario,
        [preguntaId]: respuestaId
      }
    }))
  }

  handleRespuestaMultipleChange(preguntaId, respuestaId, checked) {
    this.setState(prevState => {
      const respuestasActuales = prevState.respuestasUsuario[preguntaId] || []
      let nuevasRespuestas
      
      if (checked) {
        nuevasRespuestas = [...respuestasActuales, respuestaId]
      } else {
        nuevasRespuestas = respuestasActuales.filter(id => id !== respuestaId)
      }
      
      return {
        respuestasUsuario: {
          ...prevState.respuestasUsuario,
          [preguntaId]: nuevasRespuestas
        }
      }
    })
  }

  handleRespuestaLibreChange(preguntaId, valor) {
    this.setState(prevState => ({
      respuestasUsuario: {
        ...prevState.respuestasUsuario,
        [preguntaId]: valor
      }
    }))
  }

  async enviarEvaluacion() {
    const { respuestasUsuario, evaluacionActual } = this.state
    const estudiante_id = localStorage.getItem("cliente_id")
    
    // Validar que todas las preguntas tengan respuesta
    const preguntasSinResponder = this.state.preguntasEvaluacion.filter(pregunta => {
      const respuesta = respuestasUsuario[pregunta.preguntas.idp]
      if (pregunta.preguntas.tipo_pregunta === "SELECCION MULTIPLE") {
        return !respuesta || respuesta.length === 0
      }
      return !respuesta || respuesta.toString().trim() === ""
    })

    if (preguntasSinResponder.length > 0) {
      Swal.fire("Atención", "Por favor responde todas las preguntas antes de enviar la evaluación.", "warning")
      return
    }

    try {
      Swal.showLoading()
      
      // Preparar datos para enviar
      const datosEvaluacion = {
        evaluacion_id: evaluacionActual.id,
        respuestas: respuestasUsuario,
        fecha_envio: new Date().toISOString(),
        clase: evaluacionActual.clase_id,
        estudiante: estudiante_id
      }

      await authAxios.post("cursos/save-respuesta", datosEvaluacion)
      
      Swal.close()
      Swal.fire("¡Éxito!", "Evaluación enviada correctamente", "success")
      this.cerrarEvaluacion()
      
    } catch (error) {
      Swal.close()
      Swal.fire("Error", "No se pudo enviar la evaluación", "error")
    }
  }

  MostrarTabla() {
    Swal.showLoading()
    let bname = document.getElementById("bnombre").value
    let use = localStorage.getItem("cliente_id")
    var dato = { buscar: use, nombre: bname }
    
    authAxios
      .post("cursos/index", dato)
      .then((datosRespuesta) => {
        Swal.close()
        this.setState({ 
          datosCargados: true, 
          load: "", 
          ListaTabla: datosRespuesta.data,
          cursoSeleccionado: null,
          clasesCurso: [],
          clasesAbiertas: {},
          claseActiva: null,
          contenidosVistos: {}
        })
      })
      .catch(error => {
        Swal.close()
        Swal.fire("Error", "No se pudieron cargar los cursos", "error")
      })
  }

  componentDidMount() {
    this.MostrarTabla(1)
  }

  Enviar() {
    const form = document.getElementById("formulario")
    const formData = new FormData(form)
    Swal.showLoading()
    authAxios
      .post("transporte/guardarservicio", formData)
      .then((datosRespuesta) => {
        Swal.close()
        Swal.fire("Servicio!", datosRespuesta.data.msj.MensajeRespuesta, "success")
        document.getElementById("formulario").reset()
        this.MostrarTabla(1)
      })
      .catch()
  }

  renderPregunta(preguntaData) {
    const { preguntas, respuestas } = preguntaData
    const { respuestasUsuario } = this.state
    const respuestaActual = respuestasUsuario[preguntas.idp]

    return (
      <div key={preguntas.idp} className="card mb-4">
        <div className="card-header bg-light text-dark">
          <div className="d-flex align-items-center">
            <FontAwesomeIcon 
              icon={this.getIconoTipoPregunta(preguntas.tipo_pregunta)} 
              className="text-primary me-2"
            />
            <span className="badge bg-primary me-2">
              {preguntas.tipo_pregunta}
            </span>
            <strong  className="badge bg-primary me-2">Pregunta {preguntas.idp}</strong>
          </div>
        </div>
        <div className="card-body">
          <h6 className="card-title mb-3">{preguntas.nombre_pregunta}</h6>
          
          {preguntas.tipo_pregunta === "UNICA RESPUESTA" && (
            <div className="list-group">
              {respuestas.map((respuesta) => (
                <label key={respuesta.id} className="list-group-item">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name={`pregunta_${preguntas.idp}`}
                      value={respuesta.id}
                      checked={respuestaActual === respuesta.id}
                      onChange={() => this.handleRespuestaChange(preguntas.idp, respuesta.id)}
                    />
                    <span className="form-check-label">
                      {respuesta.descripcion}
                      {respuesta.score > 0 && (
                        <small className="text-muted ms-2">({respuesta.score} puntos)</small>
                      )}
                    </span>
                  </div>
                </label>
              ))}
            </div>
          )}

          {preguntas.tipo_pregunta === "SELECCION MULTIPLE" && (
            <div className="list-group">
              {respuestas.map((respuesta) => (
                <label key={respuesta.id} className="list-group-item">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value={respuesta.id}
                      checked={respuestaActual.includes(respuesta.id)}
                      onChange={(e) => this.handleRespuestaMultipleChange(
                        preguntas.idp, 
                        respuesta.id, 
                        e.target.checked
                      )}
                    />
                    <span className="form-check-label">
                      {respuesta.descripcion}
                      {respuesta.score > 0 && (
                        <small className="text-muted ms-2">({respuesta.score} puntos)</small>
                      )}
                    </span>
                  </div>
                </label>
              ))}
            </div>
          )}

          {preguntas.tipo_pregunta === "RESPUESTA LIBRE" && (
            <div>
              <textarea
                className="form-control"
                rows="4"
                placeholder="Escribe tu respuesta aquí..."
                value={respuestaActual || ""}
                onChange={(e) => this.handleRespuestaLibreChange(preguntas.idp, e.target.value)}
              />
              <small className="text-muted">
                Escribe tu respuesta en el espacio proporcionado.
              </small>
            </div>
          )}
        </div>
      </div>
    )
  }

  extraerVideoId(url) {
    if (!url) return ''
    
    // Para YouTube
    const match = url.match(/(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/)
    return match ? match[1] : ''
  }

  // En la función renderMapaNavegacion, reemplaza esta parte:
navegarAContenido(claseId, contenidoId) {
  this.setState({
    clasesAbiertas: {
      [claseId]: true
    },
    claseActiva: claseId,
    mapaNavegacionAbierto: false
  }, () => {
    // Pequeño delay para asegurar que el DOM se actualizó
    setTimeout(() => {
      this.scrollToElement(`contenido-${contenidoId}`);
    }, 300);
  });
}

// Función para navegar a una evaluación específica
navegarAEvaluacion(claseId, evaluacionId) {
  this.setState({
    clasesAbiertas: {
      [claseId]: true
    },
    claseActiva: claseId,
    mapaNavegacionAbierto: false
  }, () => {
    setTimeout(() => {
      this.scrollToElement(`evaluacion-${evaluacionId}`);
    }, 300);
  });
}

// Función para navegar a un foro específico
navegarAForo(claseId, foroId) {
  this.setState({
    clasesAbiertas: {
      [claseId]: true
    },
    claseActiva: claseId,
    mapaNavegacionAbierto: false
  }, () => {
    setTimeout(() => {
      this.scrollToElement(`foro-${foroId}`);
    }, 300);
  });
}

// Función genérica para scroll a cualquier elemento
// Función mejorada para scroll a cualquier elemento
scrollToElement(elementId) {
  const element = document.getElementById(elementId);
  if (element) {
    // Calcular la posición considerando el header fijo
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - 100; // 100px de offset para header
    
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
    
    // Highlight temporal más visible
    element.style.transition = 'all 0.5s ease';
    element.style.backgroundColor = 'rgba(0,123,255,0.1)';
    element.style.borderLeft = '4px solid #007bff';
    element.style.paddingLeft = '10px';
    
    setTimeout(() => {
      element.style.backgroundColor = '';
      element.style.borderLeft = '';
      element.style.paddingLeft = '';
    }, 3000);
  }
}
renderMapaNavegacion() {
    const { clasesCurso, claseActiva, mapaNavegacionAbierto, contenidosVistos } = this.state

    if (clasesCurso.length === 0) return null

    return (
      <>
        {/* Botón flotante para móvil */}
        <div className="d-md-none">
          <button
            className="btn btn-info btn-lg rounded-circle shadow-lg position-fixed"
            style={{
              bottom: '20px',
              right: '20px',
              width: '60px',
              height: '60px',
              zIndex: 1050
            }}
            onClick={this.toggleMapaNavegacion}
          >
            <FontAwesomeIcon icon={faBars} />
          </button>
        </div>

        {/* Mapa de navegación */}
        <div className={`col-md-4 ${mapaNavegacionAbierto ? 'd-block' : 'd-none d-md-block'}`}>
          <div className={`card ${mapaNavegacionAbierto ? 'position-fixed top-0 start-0 vh-100 w-75 shadow-lg' : 'sticky-top'}`}
               style={{ 
                 top: mapaNavegacionAbierto ? '0' : '20px', 
                 zIndex: mapaNavegacionAbierto ? 1060 : 1,
                 overflowY: 'auto',
                 maxHeight: mapaNavegacionAbierto ? '100vh' : '80vh'
               }}>
            
            {/* Header del mapa en móvil con botón cerrar */}
            {mapaNavegacionAbierto && (
              <div className="card-header bg-info text-white d-flex justify-content-between align-items-center">
                <h6 className="mb-0">
                  <FontAwesomeIcon icon={faMap} className="me-2" />
                  <strong>Mapa de Navegación</strong>
                </h6>
                <button 
                  className="btn btn-light btn-sm"
                  onClick={this.toggleMapaNavegacion}
                >
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              </div>
            )}
            
            {/* Contenido del mapa */}
            {!mapaNavegacionAbierto && (
              <div className="card-header bg-info text-white">
                <FontAwesomeIcon icon={faMap} className="me-2" />
                <strong>Mapa de Navegación</strong>
              </div>
            )}
            
            <div className="card-body p-0">
              <div className="list-group list-group-flush">
                {clasesCurso.map((clase, index) => (
                  <div key={clase.materia.ccc}>
                    {/* Botón principal de la clase */}
                    <button
                      className={`list-group-item list-group-item-action d-flex justify-content-between align-items-center ${
                        claseActiva === clase.materia.ccc ? 'active' : ''
                      }`}
                      onClick={() => this.navegarAClase(clase.materia.ccc)}
                    >
                      <div className="d-flex align-items-center">
                        <FontAwesomeIcon 
                          icon={faGraduationCap} 
                          className="me-2" 
                          size="sm"
                        />
                        <div>
                          <small className={claseActiva === clase.materia.ccc ? 'text-white' : 'text-muted'}>
                            {clase.materia.titulo}
                          </small>
                        </div>
                      </div>
                      <FontAwesomeIcon 
                        icon={faEye} 
                        size="sm"
                        className={claseActiva === clase.materia.ccc ? 'text-white' : 'text-muted'}
                      />
                    </button>
                    
                    {/* Sub-items para contenidos - CLICKEABLES */}
                    {clase.contenidos.length > 0 && (
                      <div className="list-group list-group-flush">
                        {clase.contenidos.map((contenido, contIndex) => (
                          <button
                            key={contenido.id}
                            className="list-group-item list-group-item-action ps-4 py-2 small d-flex justify-content-between align-items-center"
                            onClick={() => this.navegarAContenido(clase.materia.ccc, contenido.clase_contenido_id)}
                          >
                            <div className="d-flex align-items-center">
                              <FontAwesomeIcon 
                                icon={this.getIconoPorTipo(contenido.archivo)} 
                                className="me-2 text-primary"
                                size="xs"
                              />
                              {contenido.descripcion}
                            </div>
                            <FontAwesomeIcon 
                              icon={contenido.visto || contenidosVistos[contenido.clase_contenido_id] ? faCheckCircle : faCircle}
                              className={contenido.visto || contenidosVistos[contenido.clase_contenido_id] ? "text-success" : "text-muted"}
                              size="xs"
                            />
                          </button>
                        ))}
                      </div>
                    )}
                    
                    {/* Sub-items para evaluaciones - CLICKEABLES */}
                    {clase.evaluaciones.length > 0 && (
                      <div className="list-group list-group-flush">
                        {clase.evaluaciones.map((evaluacion, evalIndex) => (
                          <button
                            key={evaluacion.id}
                            className="list-group-item list-group-item-action ps-4 py-2 small"
                            onClick={() => this.navegarAEvaluacion(clase.materia.ccc, evaluacion.evaluacion)}
                          >
                            <FontAwesomeIcon 
                              icon={faTasks} 
                              className="me-2 text-warning"
                              size="xs"
                            />
                            {evaluacion.descripcion}
                            {evaluacion.nota !== null && (
                              <span className="badge bg-success ms-2">
                                {evaluacion.nota} pts
                              </span>
                            )}
                          </button>
                        ))}
                      </div>
                    )}

                    {/* Sub-items para foros - CLICKEABLES */}
                    {clase.foros && clase.foros.length > 0 && (
                      <div className="list-group list-group-flush">
                        {clase.foros.map((foro, foroIndex) => (
                          <button
                            key={foro.id}
                            className="list-group-item list-group-item-action ps-4 py-2 small"
                            onClick={() => this.navegarAForo(clase.materia.ccc, foro.id)}
                          >
                            <FontAwesomeIcon 
                              icon={faComments} 
                              className="me-2 text-info"
                              size="xs"
                            />
                            {foro.nombre}
                            {foro.respuesta_existente && (
                              <span className="badge bg-success ms-2">
                                ✓
                              </span>
                            )}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
            <div className="card-footer bg-light">
              <small className="text-muted">
                {clasesCurso.length} {clasesCurso.length === 1 ? 'clase' : 'clases'} en total
              </small>
            </div>
          </div>
        </div>
      </>
    )
  }
  render() {
    const filteredList = this.getFilteredList()
    const { 
      cursoSeleccionado, 
      clasesCurso,
      clasesAbiertas,
      evaluacionAbierta,
      preguntasEvaluacion,
      evaluacionActual,
      videoAbierto,
      videoUrl,
      documentoAbierto,
      documentoUrl,
      documentoNombre,
      certificadoAbierto,
      certificadoData,
      claseActiva,
      foroAbierto,
      foroActual,
      forosClase,
      respuestaForo,
      archivoForo,
      respuestaExistente,
      documentoForoAbierto,
      documentoForoUrl,
      documentoForoNombre,
      documentoForoTipo,
      mapaNavegacionAbierto,
      contenidosVistos
    } = this.state

    const videoId = this.extraerVideoId(videoUrl)
    const estudiante_nombre = localStorage.getItem("cliente_nombre") || "Estudiante";

    return (
      <div className="content">
        <div className="container-fluid">
          <br />
          
          {/* Overlay para móvil cuando el mapa está abierto */}
          {mapaNavegacionAbierto && (
            <div 
              className="d-md-none position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50"
              style={{ zIndex: 1040 }}
              onClick={this.toggleMapaNavegacion}
            ></div>
          )}

          {/* Modal de Documento del Foro */}
          {/* Modal de Foro */}
            {/* Modal de Foro */}
{foroAbierto && (
  <div className="modal show d-block" tabIndex="-1" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
    <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div className="modal-content">
        <div className="modal-header bg-info text-white">
          <h5 className="modal-title">
            <FontAwesomeIcon icon={faComments} className="me-2" />
            Foro: {foroActual?.titulo}
          </h5>
          <button 
            type="button" 
            className="btn-close btn-close-white" 
            onClick={this.cerrarForo}
          ></button>
        </div>
        <div className="modal-body">
          
          {/* Información del foro */}
          {forosClase.length > 0 && forosClase.map((foro) => (
            <div key={foro.id} className="card mb-4">
              <div className="card-header bg-light">
                <div className="d-flex justify-content-between align-items-center">
                  <h6 className="mb-0">
                    <FontAwesomeIcon icon={faComments} className="me-2" />
                    {foro.nombre}
                  </h6>
                  <div>
                    <small className="text-muted">
                      <FontAwesomeIcon icon={faCalendar} className="me-1" />
                      Inicio: {new Date(foro.fecha_inicio).toLocaleString()}
                    </small>
                    <br />
                    <small className="text-muted">
                      <FontAwesomeIcon icon={faClock} className="me-1" />
                      Cierre: {new Date(foro.fecha_final).toLocaleString()}
                    </small>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <p>{foro.descripcion}</p>
                
                {/* Documento adjunto del foro */}
                {foro.documento && (
                  <div className="mb-3">
                    <a 
                      href={`${apiImage}${foro.documento}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-outline-primary btn-sm"
                      download
                    >
                      <FontAwesomeIcon icon={faDownload} className="me-1" />
                      Descargar Documento del Foro
                    </a>
                  </div>
                )}

                {/* Sección de respuestas tipo Facebook */}
                <div className="mt-4">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="mb-0">
                      <FontAwesomeIcon icon={faComments} className="me-2" />
                      Respuestas ({foro.total_respuestas || 0})
                    </h6>
                    
                    {/* Botón para ver/ocultar respuestas */}
                    {foro.total_respuestas > 0 && (
                      <button
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => this.toggleRespuestas(foro.id)}
                      >
                        <FontAwesomeIcon 
                          icon={foro.mostrarRespuestas ? faChevronUp : faChevronDown} 
                          className="me-1" 
                        />
                        {foro.mostrarRespuestas ? 'Ocultar' : 'Ver'} respuestas
                      </button>
                    )}
                  </div>

                  {/* Lista de respuestas */}
                  {foro.mostrarRespuestas && foro.respuestas && foro.respuestas.length > 0 && (
                    <div className="respuestas-container">
                      {foro.respuestas.map((respuesta) => (
                        <div 
                          key={respuesta.id} 
                          className={`card mb-2 ${respuesta.es_mi_respuesta ? 'border-primary' : ''}`}
                        >
                          <div className="card-body p-3">
                            <div className="d-flex align-items-start">
                              <div className="flex-grow-1">
                                <div className="d-flex justify-content-between align-items-start mb-2">
                                  <div>
                                    <h6 className="mb-0">
                                      <FontAwesomeIcon 
                                        icon={faUser} 
                                        className={`me-2 ${respuesta.es_mi_respuesta ? 'text-primary' : 'text-muted'}`}
                                      />
                                      {respuesta.estudiante_nombre}
                                      {respuesta.es_mi_respuesta && (
                                        <span className="badge bg-primary ms-2">Tú</span>
                                      )}
                                    </h6>
                                    <small className="text-muted">
                                      <FontAwesomeIcon icon={faClock} className="me-1" />
                                      {/* CORREGIDO: usar fecha_respusta en lugar de fecha_respuesta */}
                                      {new Date(respuesta.fecha_respusta).toLocaleString()}
                                    </small>
                                  </div>
                                  
                                  {/* Calificación */}
                                  {respuesta.calificacion && (
                                    <span className="badge bg-success">
                                      Calificación: {respuesta.calificacion}
                                    </span>
                                  )}
                                </div>
                                
                                <p className="mb-2">{respuesta.comentario}</p>
                                
                                {/* Documento adjunto de la respuesta */}
                                {respuesta.documento_adjunto && (
                                  <div className="mb-2">
                                    <button
                                      className="btn btn-outline-secondary btn-sm"
                                      onClick={() => this.abrirDocumentoForo(
                                        respuesta.documento_adjunto, 
                                        `Documento de ${respuesta.estudiante_nombre}`
                                      )}
                                    >
                                      <FontAwesomeIcon 
                                        icon={this.getIconoPorTipo(respuesta.documento_adjunto)} 
                                        className="me-1" 
                                      />
                                      Ver documento adjunto
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Mensaje cuando no hay respuestas */}
                  {(!foro.respuestas || foro.respuestas.length === 0) && (
                    <div className="text-center text-muted py-3">
                      <FontAwesomeIcon icon={faComments} size="2x" className="mb-2" />
                      <p>No hay respuestas aún</p>
                      <small>Sé el primero en participar en este foro</small>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}

          {/* Estado de la respuesta del usuario */}
          {forosClase.length > 0 && forosClase[0].mi_respuesta ? (
            <div className="alert alert-success">
              <FontAwesomeIcon icon={faCheckSquare} className="me-2" />
              <strong>Ya has enviado tu respuesta a este foro</strong>
              <br />
              <small>
                {/* CORREGIDO: usar fecha_respusta en lugar de fecha_respuesta */}
                Fecha de envío: {new Date(forosClase[0].mi_respuesta.fecha_respusta).toLocaleString()}
                {forosClase[0].calificacion_mi_respuesta && (
                  <span className="ms-2">
                    | Calificación: <strong>{forosClase[0].calificacion_mi_respuesta}</strong>
                  </span>
                )}
              </small>
            </div>
          ) : (
            <div className="alert alert-warning">
              <FontAwesomeIcon icon={faInfo} className="me-2" />
              <strong>No has enviado tu respuesta aún</strong>
              <br />
              <small>Asegúrate de enviar tu respuesta antes de la fecha de cierre</small>
            </div>
          )}

          {/* Formulario de respuesta */}
          {forosClase.length > 0 && !forosClase[0].mi_respuesta && (
            <div className="card">
              <div className="card-header bg-primary text-white">
                <h6 className="mb-0">
                  <FontAwesomeIcon icon={faPaperPlane} className="me-2" />
                  Tu Respuesta
                </h6>
              </div>
              <div className="card-body">
                <div className="mb-3">
                  <label className="form-label">
                    <strong>Comentario *</strong>
                  </label>
                  <textarea
                    className="form-control"
                    rows="6"
                    placeholder="Escribe tu respuesta aquí..."
                    value={respuestaForo}
                    onChange={this.handleComentarioChange}
                  />
                  <small className="text-muted">
                    Escribe tu respuesta detallada al foro. Este campo es obligatorio.
                  </small>
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    <strong>Documento Adjunto (Opcional)</strong>
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    onChange={this.handleArchivoForoChange}
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  />
                  <small className="text-muted">
                    Puedes adjuntar un documento PDF, Word o imagen (máx. 10MB)
                  </small>
                </div>

                <div className="alert alert-info">
                  <FontAwesomeIcon icon={faInfo} className="me-2" />
                  <strong>Importante:</strong> Solo podrás enviar una respuesta por foro. 
                  Una vez enviada, no podrás modificarla.
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="modal-footer">
          <button 
            type="button" 
            className="btn btn-secondary" 
            onClick={this.cerrarForo}
          >
            Cerrar
          </button>
          {forosClase.length > 0 && !forosClase[0].mi_respuesta && (
            <button 
              type="button" 
              className="btn btn-success" 
              onClick={this.enviarRespuestaForo}
              disabled={!respuestaForo.trim()}
            >
              <FontAwesomeIcon icon={faPaperPlane} className="me-2" />
              Enviar Respuesta
            </button>
          )}
        </div>
      </div>
    </div>
  </div>
)}

          {/* Modal de Certificado */}
          {certificadoAbierto && certificadoData && (
    <div className="modal show d-block" tabIndex="-1" style={{backgroundColor: 'rgba(0,0,0,0.8)'}}>
        <div className="modal-dialog modal-xl modal-dialog-centered">
            <div className="modal-content">
                <div className="modal-header bg-success text-white">
                    <h5 className="modal-title">
                        <FontAwesomeIcon icon={faCertificate} className="me-2" />
                        Certificado de Finalización - {certificadoData.curso_nombre}
                    </h5>
                    <button 
                        type="button" 
                        className="btn-close btn-close-white" 
                        onClick={this.cerrarCertificado}
                    ></button>
                </div>
                <div className="modal-body">
                    <div className="alert alert-info">
                        <FontAwesomeIcon icon={faInfo} className="me-2" />
                        Puedes imprimir este certificado usando el botón "Imprimir" o abrirlo en una nueva ventana para guardarlo como PDF.
                    </div>
                    
                    {/* Vista previa del certificado */}
                    <div className="certificate-preview border p-4 bg-white" id="certificado-content">
                        {/* Encabezado con logo y datos de la empresa */}
                        <div className="certificate-header text-center mb-4">
                            <div className="row align-items-center">
                                <div className="col-md-2">
                                    <img 
                                        src="https://documentos2024-aoa.s3.bhs.io.cloud.ovh.net/9999/Learning/logov2.png" 
                                        alt="Logo de la empresa" 
                                        className="img-fluid"
                                        style={{ maxHeight: '100px' }}
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                        }}
                                    />
                                </div>
                                <div className="col-md-8">
                                    <h1 className="text-success mb-1" style={{ fontSize: '2.5rem', fontWeight: 'bold' }}>
                                        CERTIFICADO
                                    </h1>
                                    <p className="text-muted mb-0">DE FINALIZACIÓN Y APROBACIÓN</p>
                                    <div className="border-top border-success mx-auto mt-2" style={{ width: '200px' }}></div>
                                </div>
                                <div className="col-md-2 text-end">
                                    <div className="certificate-code bg-light p-2 rounded">
                                        <small className="text-muted d-block">Código</small>
                                        <strong className="text-primary">{certificadoData.codigo_certificado}</strong>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Información de la empresa */}
                        <div className="company-info text-center mb-4">
                            <h3 className="text-primary mb-1">{certificadoData.empresa_nombre}</h3>
                            <p className="text-muted mb-1">NIT: {certificadoData.empresa_nit}</p>
                            {certificadoData.empresa_direccion && (
                                <p className="text-muted mb-0">{certificadoData.empresa_direccion}</p>
                            )}
                         
                        </div>

                        {/* Cuerpo principal del certificado */}
                        <div className="certificate-body text-center py-4">
                            <div className="mb-4">
                                <p className="lead text-dark mb-3">La entidad certifica que:</p>
                                <h2 className="text-dark border-bottom border-primary d-inline-block px-4 pb-2 mb-3" 
                                    style={{ borderWidth: '3px', fontSize: '2rem' }}>
                                    {certificadoData.estudiante_nombre_completo}
                                </h2>
                                <p className="lead text-dark mb-4">Ha completado satisfactoriamente el programa de formación:</p>
                                <h3 className="text-primary mb-3" style={{ fontSize: '1.8rem' }}>
                                    "{certificadoData.curso_nombre}"
                                </h3>
                                <p className="text-muted">Código del curso: {certificadoData.curso_codigo}</p>
                            </div>

                            {/* Estadísticas de rendimiento */}
                            <div className="performance-stats row justify-content-center mb-4">
                                <div className="col-md-3">
                                    <div className="stat-card bg-light p-3 rounded">
                                        <h4 className="text-success mb-1">Aprobado el {certificadoData.fecha_emision}</h4>
                                        <small className="text-muted">8 Horas de teoría </small>
                                    </div>
                                </div>
                             
                            </div>

                            {/* Mensaje de felicitación */}
                            <div className="congratulations-message bg-light p-3 rounded mb-4">
                                <p className="mb-0 text-dark">
                                   
                                    Por haber demostrado dedicación, compromiso y excelencia académica durante el desarrollo del programa.
                                </p>
                            </div>
                        </div>

                        {/* Fechas y firmas */}
                        <div className="certificate-footer mt-4">
                            <div className="row">
                               
                                <div className="col-md-6">
                                    <div className="signature-space text-center">
                                        <div className="border-top border-dark mx-auto mt-2" style={{ width: '200px' }}></div>
                                        <p className="text-muted mt-2">Firma y Sello Institucional</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Información adicional */}
                        <div className="additional-info mt-4 pt-3 border-top">
                            <div className="row text-center">
                                <div className="col-12">
                                    <small className="text-muted">
                                        Este certificado puede ser verificado mediante el código: <strong>{certificadoData.codigo_certificado}</strong>
                                    </small>
                                    <br />
                                    <small className="text-muted">
                                        Válido según los registros académicos de {certificadoData.empresa_nombre}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    {/* Botones de acción */}
                    <div className="mt-4 text-center">
                      
                        
                       
                    </div>
                </div>
            </div>
        </div>
    </div>
)}

          {/* Modal de Video */}
          {videoAbierto && (
            <div className="modal show d-block" tabIndex="-1" style={{backgroundColor: 'rgba(0,0,0,0.8)'}}>
              <div className="modal-dialog modal-xl modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header bg-dark text-white">
                    <h5 className="modal-title">
                      <FontAwesomeIcon icon={faPlay} className="me-2" />
                      Reproduciendo Video
                    </h5>
                    <button 
                      type="button" 
                      className="btn-close btn-close-white" 
                      onClick={this.cerrarVideo}
                    ></button>
                  </div>
                  <div className="modal-body p-0">
                    <div className="ratio ratio-16x9">
                      <iframe
                        src={`https://www.youtube.com/embed/${videoId}`}
                        title="Video de la clase"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Modal de Documento */}
          {documentoAbierto && (
            <div className="modal show d-block" tabIndex="-1" style={{backgroundColor: 'rgba(0,0,0,0.8)'}}>
              <div className="modal-dialog modal-xl modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header bg-dark text-white">
                    <h5 className="modal-title">
                      <FontAwesomeIcon icon={faFilePdf} className="me-2" />
                      {documentoNombre}
                    </h5>
                    <div>
                      <a 
                        href={documentoUrl} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="btn btn-success btn-sm me-2"
                        download
                      >
                        <FontAwesomeIcon icon={faDownload} className="me-1" />
                        Descargar
                      </a>
                      <button 
                        type="button" 
                        className="btn-close btn-close-white" 
                        onClick={this.cerrarDocumento}
                      ></button>
                    </div>
                  </div>
                  <div className="modal-body p-0">
                    <div style={{height: '80vh'}}>
                      <iframe
                        src={documentoUrl}
                        title={documentoNombre}
                        width="100%"
                        height="100%"
                        style={{border: 'none'}}
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Modal de Evaluación */}
          {evaluacionAbierta && (
            <div className="modal show d-block" tabIndex="-1" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
              <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content">
                  <div className="modal-header bg-primary text-white">
                    <h5 className="modal-title">
                      <FontAwesomeIcon icon={faTasks} className="me-2" />
                      Evaluación: {evaluacionActual?.titulo}
                    </h5>
                    <button 
                      type="button" 
                      className="btn-close btn-close-white" 
                      onClick={this.cerrarEvaluacion}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="alert alert-info">
                      <FontAwesomeIcon icon={faInfo} className="me-2" />
                      Responde todas las preguntas según el tipo indicado. No podrás modificar tus respuestas después de enviar.
                    </div>
                    
                    {preguntasEvaluacion.map(preguntaData => 
                      this.renderPregunta(preguntaData)
                    )}
                  </div>
                  <div className="modal-footer">
                    <button 
                      type="button" 
                      className="btn btn-secondary" 
                      onClick={this.cerrarEvaluacion}
                    >
                      Cancelar
                    </button>
                    <button 
                      type="button" 
                      className="btn btn-success" 
                      onClick={this.enviarEvaluacion}
                    >
                      <FontAwesomeIcon icon={faPaperPlane} className="me-2" />
                      Enviar Evaluación
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Modal de Foro */}
          {foroAbierto && (
            <div className="modal show d-block" tabIndex="-1" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
              <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content">
                  <div className="modal-header bg-info text-white">
                    <h5 className="modal-title">
                      <FontAwesomeIcon icon={faComments} className="me-2" />
                      Foro: {foroActual?.titulo}
                    </h5>
                    <button 
                      type="button" 
                      className="btn-close btn-close-white" 
                      onClick={this.cerrarForo}
                    ></button>
                  </div>
                  <div className="modal-body">
                    
                    {/* Información del foro */}
                    {forosClase.length > 0 && forosClase.map((foro) => (
                      <div key={foro.id} className="card mb-4">
                        <div className="card-header bg-light">
                          <div className="d-flex justify-content-between align-items-center">
                            <h6 className="mb-0">
                              <FontAwesomeIcon icon={faComments} className="me-2" />
                              {foro.nombre}
                            </h6>
                            <div>
                              <small className="text-muted">
                                <FontAwesomeIcon icon={faCalendar} className="me-1" />
                                Inicio: {new Date(foro.fecha_inicio).toLocaleString()}
                              </small>
                              <br />
                              <small className="text-muted">
                                <FontAwesomeIcon icon={faClock} className="me-1" />
                                Cierre: {new Date(foro.fecha_final).toLocaleString()}
                              </small>
                            </div>
                          </div>
                        </div>
                        <div className="card-body">
                          <p>{foro.descripcion}</p>
                          
                          {/* Documento adjunto del foro */}
                          {foro.documento && (
                            <div className="mb-3">
                              <a 
                                href={`${apiImage}${foro.documento}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-primary btn-sm"
                                download
                              >
                                <FontAwesomeIcon icon={faDownload} className="me-1" />
                                Descargar Documento del Foro
                              </a>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}

                    {/* Estado de la respuesta */}
                    {respuestaExistente ? (
                      <div className="alert alert-success">
                        <FontAwesomeIcon icon={faCheckSquare} className="me-2" />
                        <strong>Ya has enviado tu respuesta a este foro</strong>
                        <br />
                        <small>
                          Fecha de envío: {new Date(respuestaExistente.fecha_respuesta).toLocaleString()}
                          {respuestaExistente.calificacion && (
                            <span className="ms-2">
                              | Calificación: <strong>{respuestaExistente.calificacion}</strong>
                            </span>
                          )}
                        </small>
                      </div>
                    ) : (
                      <div className="alert alert-warning">
                        <FontAwesomeIcon icon={faInfo} className="me-2" />
                        <strong>No has enviado tu respuesta aún</strong>
                        <br />
                        <small>Asegúrate de enviar tu respuesta antes de la fecha de cierre</small>
                      </div>
                    )}

                    {/* Formulario de respuesta */}
                    {!respuestaExistente && (
                      <div className="card">
                        <div className="card-header bg-primary text-white">
                          <h6 className="mb-0">
                            <FontAwesomeIcon icon={faPaperPlane} className="me-2" />
                            Tu Respuesta
                          </h6>
                        </div>
                        <div className="card-body">
                          <div className="mb-3">
                            <label className="form-label">
                              <strong>Comentario *</strong>
                            </label>
                            <textarea
                              className="form-control"
                              rows="6"
                              placeholder="Escribe tu respuesta aquí..."
                              value={respuestaForo}
                              onChange={this.handleComentarioChange}
                            />
                            <small className="text-muted">
                              Escribe tu respuesta detallada al foro. Este campo es obligatorio.
                            </small>
                          </div>

                          <div className="mb-3">
                            <label className="form-label">
                              <strong>Documento Adjunto (Opcional)</strong>
                            </label>
                            <input
                              type="file"
                              className="form-control"
                              onChange={this.handleArchivoForoChange}
                              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                            />
                            <small className="text-muted">
                              Puedes adjuntar un documento PDF, Word o imagen (máx. 10MB)
                            </small>
                          </div>

                          <div className="alert alert-info">
                            <FontAwesomeIcon icon={faInfo} className="me-2" />
                            <strong>Importante:</strong> Solo podrás enviar una respuesta por foro. 
                            Una vez enviada, no podrás modificarla.
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="modal-footer">
                    <button 
                      type="button" 
                      className="btn btn-secondary" 
                      onClick={this.cerrarForo}
                    >
                      Cerrar
                    </button>
                    {!respuestaExistente && (
                      <button 
                        type="button" 
                        className="btn btn-success" 
                        onClick={this.enviarRespuestaForo}
                        disabled={!respuestaForo.trim()}
                      >
                        <FontAwesomeIcon icon={faPaperPlane} className="me-2" />
                        Enviar Respuesta
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Vista principal de cursos */}
          {!cursoSeleccionado && !evaluacionAbierta && !videoAbierto && !documentoAbierto && !certificadoAbierto && !foroAbierto && (
            <div className="card">
              <div className="card-body">
                <h4>Mis Cursos Asignados</h4>
                <hr />
                <div className="row">
                  <div className="col-xl-3">
                    <input
                      style={{ textTransform: "uppercase" }}
                      type="text"
                      id="bnombre"
                      name="bnombre"
                      placeholder="Buscar por curso"
                      className="form-control form-control-sm"
                    />
                  </div>
                  <div className="col-xl-3">
                    <button 
                      id="bt" 
                      name="bt" 
                      className="btn btn-primary" 
                      onClick={() => this.MostrarTabla(1)}
                    >
                      &nbsp;&nbsp;Filtrar
                    </button>
                  </div>
                </div>
                
                <br />
                
                {/* Cards de cursos */}
                <div className="row">
                  {filteredList.map((curso, i) => (
                    <div key={curso.id} className="col-md-6 col-lg-6 mb-4">
                      <div className="card h-100 shadow-sm overflow-hidden">
                        {/* Imagen del curso como banner superior */}
                        {curso.imagen_curso && (
                          <div 
                            className="card-img-top position-relative"
                            style={{
                              height: '140px',
                              backgroundImage: `url(${apiImage}${curso.imagen_curso})`,
                              backgroundSize: 'cover',
                              backgroundPosition: 'center',
                              backgroundRepeat: 'no-repeat'
                            }}
                          >
                            {/* Overlay oscuro para mejor contraste del texto */}
                            <div 
                              className="position-absolute top-0 start-0 w-100 h-100"
                              style={{
                                background: 'linear-gradient(to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.7))'
                              }}
                            ></div>
                            
                            {/* Información superpuesta sobre la imagen */}
                            <div className="position-absolute bottom-0 start-0 p-3 w-100 text-white">
                              <div className="d-flex justify-content-between align-items-end">
                                <div>
                                  <h6 className="mb-1 fw-bold">
                                    <FontAwesomeIcon icon={faBook} className="me-2" />
                                    {curso.codigo}
                                  </h6>
                                  <h5 className="mb-0 fw-bold">{curso.descripcion}</h5>
                                </div>
                                {/* Icono de certificado en el header EnviarCertificado */}
                                {curso.materias_completadas === curso.total_materias && curso.total_materias > 0 && (
                                  <><button
                                    type="button"
                                    className="btn btn-success btn-sm rounded-circle"
                                    onClick={() => this.descargarCertificado(curso)}
                                    title="Ver certificado"
                                    style={{ width: '35px', height: '35px', padding: 0 }}
                                  >
                                    <FontAwesomeIcon icon={faCertificate} />
                                  </button> 
                                   <button
                                    type="button"
                                    className="btn btn-success btn-sm rounded-circle"
                                    onClick={() => this.EnviarCertificado(curso)}
                                    title="Enviar certificado al correo"
                                    style={{ width: '35px', height: '35px', padding: 0 }}
                                  >
                                    <FontAwesomeIcon icon={faPrint} />
                                  </button></>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        
                        {/* Si no hay imagen, mostrar el header normal */}
                        {!curso.imagen_curso && (
                          <div className="card-header bg-danger text-white d-flex justify-content-between align-items-center">
                            <h6 className="mb-0">
                              <FontAwesomeIcon icon={faBook} className="me-2" />
                              {curso.codigo}
                            </h6>
                            {curso.materias_completadas === curso.total_materias && curso.total_materias > 0 && (
                              <button
                                type="button"
                                className="btn btn-success btn-sm rounded-circle"
                                onClick={() => this.descargarCertificado(curso)}
                                title="Descargar certificado"
                                style={{ width: '30px', height: '30px', padding: 0 }}
                              >
                                <FontAwesomeIcon icon={faCertificate} />
                              </button>
                            )}
                          </div>
                        )}
                        
                        <div className="card-body">
                          {/* Solo mostrar el título si hay imagen, porque ya está en el banner */}
                          {!curso.imagen_curso && (
                            <h4 className="card-title text-primary">{curso.descripcion}</h4>
                          )}
                          
                          <div className="mb-2">
                            <small className="text-muted">
                              <FontAwesomeIcon icon={faUser} className="me-1" />
                              <strong>Docente:</strong> {curso.nombre}
                            </small>
                          </div>
                          
                          <div className="mb-2">
                            <small className="text-muted">
                              <FontAwesomeIcon icon={faCalendar} className="me-1" />
                              <strong>Inicio:</strong> {new Date(curso.fecha_inicio).toLocaleDateString()}
                            </small>
                          </div>
                          
                          <div className="mb-3">
                            <small className="text-muted">
                              <FontAwesomeIcon icon={faCalendar} className="me-1" />
                              <strong>Fin:</strong> {new Date(curso.fecha_final).toLocaleDateString()}
                            </small>
                          </div>
                          
                          <div className="mb-3">
                            <small className="text-muted">
                              <FontAwesomeIcon icon={faFolder} className="me-1" />
                              <strong>Cantidad de Clases Completadas: </strong> {curso.materias_completadas} / {curso.total_materias}
                            </small>
                          </div>
                          
                          {/* Información de la empresa */}
                          {curso.empresa && (
                            <div className="mb-3">
                              <small className="text-muted">
                                <FontAwesomeIcon icon={faBuilding} className="me-1" />
                                <strong>Empresa:</strong> {curso.empresa}
                                {curso.nit > 0 && ` - NIT: ${curso.nit}`}
                              </small>
                            </div>
                          )}
                          
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              {curso.promedio_notas > 0 ? (
                                <span className="badge bg-success">
                                  Promedio: {curso.promedio_notas} Puntos
                                </span>
                              ) : (
                                <span className="badge bg-warning text-dark">
                                  Sin iniciar
                                </span>
                              )}
                            </div>
                            
                            <div className="d-flex gap-2">
                              <button
                                type="button"
                                className="btn btn-info btn-sm"
                                onClick={() => this.VerContenidoCurso(curso.id)}
                              >
                                <FontAwesomeIcon icon={faInfo} /> Ver Contenido
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Vista de contenido del curso CON MAPA DE NAVEGACIÓN */}
          {cursoSeleccionado && !evaluacionAbierta && !videoAbierto && !documentoAbierto && !certificadoAbierto && !foroAbierto && (
            <div className="card">
              <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                <h4 className="mb-0">
                  <FontAwesomeIcon icon={faBook} className="me-2" />
                  Contenido del Curso
                </h4>
                <div>
                  <button
                    className="btn btn-light btn-sm me-2"
                    onClick={() => this.setState({ 
                      cursoSeleccionado: null, 
                      clasesCurso: [],
                      clasesAbiertas: {},
                      claseActiva: null,
                      contenidosVistos: {}
                    })}
                  >
                    Volver a Cursos
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  {/* Mapa de Navegación */}
                  {this.renderMapaNavegacion()}
                  
                  {/* Contenido principal del curso */}
                  <div className={`${mapaNavegacionAbierto ? 'd-none d-md-block col-md-8' : 'col-12 col-md-8'}`}>
                    {/* Lista de clases */}
                    <div className="row">
                      {clasesCurso.map((clase, index) => (
                        <div 
                          key={clase.materia.ccc} 
                          id={`clase-${clase.materia.ccc}`}
                          className="col-12 mb-4"
                        >
                          <div className={`card shadow-sm border-${
                            claseActiva === clase.materia.ccc ? 'primary' : 'light'
                          }`}>
                            <div 
                              className={`card-header ${
                                claseActiva === clase.materia.ccc ? 'bg-primary text-white' : 'bg-light text-dark'
                              } d-flex justify-content-between align-items-center cursor-pointer`}
                              onClick={() => this.toggleClase(clase.materia.ccc)}
                              style={{ cursor: 'pointer' }}
                            >
                              <div className="w-100">
                                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
                                  <div className="mb-2 mb-md-0">
                                    <h5 className="mb-1">
                                      <FontAwesomeIcon icon={faGraduationCap} className="me-2" />
                                      {clase.materia.titulo}
                                    </h5>
                                    <small className={claseActiva === clase.materia.ccc ? 'text-white' : 'text-muted'}>
                                      <FontAwesomeIcon icon={faUser} className="me-1" />
                                      Docente: {clase.materia.nombre}
                                    </small>
                                  </div>
                                  <div className="d-flex flex-wrap gap-2">
                                    <span className={`badge ${
                                      claseActiva === clase.materia.ccc ? 'bg-light text-primary' : 'bg-secondary'
                                    }`}>
                                      {clase.total_contenidos} contenidos
                                    </span>
                                    <span className={`badge ${
                                      claseActiva === clase.materia.ccc ? 'bg-light text-primary' : 'bg-info'
                                    }`}>
                                      {clase.evaluaciones.length} evaluaciones
                                    </span>
                                    {clase.foros && clase.foros.length > 0 && (
                                      <span className={`badge ${
                                        claseActiva === clase.materia.ccc ? 'bg-light text-primary' : 'bg-success'
                                      }`}>
                                        {clase.foros.length} foros
                                      </span>
                                    )}
                                    <FontAwesomeIcon 
                                      icon={clasesAbiertas[clase.materia.ccc] ? faChevronUp : faChevronDown} 
                                      className={claseActiva === clase.materia.ccc ? 'text-white' : ''}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                            {/* Contenido desplegable */}
                            {clasesAbiertas[clase.materia.ccc] && (
                              <div className="card-body">
                                
                                {/* Contenidos */}
                                {clase.contenidos.length > 0 && (
      <div className="mb-4">
        <h6 className="text-primary mb-3">
          <FontAwesomeIcon icon={faBook} className="me-2" />
          Material de Estudio
        </h6>
        <div className="row">
          {clase.contenidos.map((contenido) => (
            <div key={contenido.id} className="col-md-12 mb-3" id={`contenido-${contenido.clase_contenido_id}`}>
              <div className="card border">
                <div className="card-body">
                  <div className="">
                  
                    
                    <div className="flex-grow-1">
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <h6 className="card-title mb-1">
                          <FontAwesomeIcon 
                      icon={this.getIconoPorTipo(contenido.archivo)} 
                      className="text-primary mt-1 me-3"
                      size="lg"
                    />
                    {contenido.descripcion}
                          <button
                        className={`btn btn-sm ${contenido.visto || contenidosVistos[contenido.clase_contenido_id] ? 'btn-success' : 'btn-outline-secondary'}`}
                        onClick={() => this.marcarContenidoVisto(contenido.clase_contenido_id, clase.materia.ccc)}
                        title={contenido.visto || contenidosVistos[contenido.clase_contenido_id] ? "Marcado como visto" : "Marcar como visto"}
                      >
                        <FontAwesomeIcon 
                          icon={contenido.visto || contenidosVistos[contenido.clase_contenido_id] ? faCheckCircle : faCircle}
                        className={contenido.visto || contenidosVistos[contenido.clase_contenido_id] ? "text-white" : "text-muted"}
                        size="lg"
                        />
                      </button>
                        </h6>
                        {contenido.visto || contenidosVistos[contenido.clase_contenido_id] && (
                          <span className="badge bg-success ms-2">
                            <FontAwesomeIcon icon={faCheckCircle} className="me-1" />
                            Visto
                          </span>
                        )}
                      </div>
                      {/* Mostrar video directamente si existe */}
                      {contenido.url_video && (
                        <div className="mb-3">
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="text-muted mb-0">
                              <FontAwesomeIcon icon={faPlay} className="me-2 text-danger" />
                              Video de la Clase
                            </h6>
                            <button
                              className="btn btn-outline-danger btn-sm"
                              onClick={() => this.abrirVideo(contenido.url_video, contenido.clase_contenido_id, clase.materia.ccc)}
                            >
                              <FontAwesomeIcon icon={faPlay} className="me-1" />
                              Ver en Pantalla Completa
                            </button>
                          </div>
                          
                          {/* Reproductor de video integrado */}
                          <div className="border rounded bg-dark">
                            <div className="ratio ratio-16x9">
                              {this.extraerVideoId(contenido.url_video) ? (
                                // Video de YouTube
                                <iframe
                                  src={`https://www.youtube.com/embed/${this.extraerVideoId(contenido.url_video)}`}
                                  title={`Video: ${contenido.descripcion}`}
                                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                  allowFullScreen
                                  style={{border: 'none'}}
                                ></iframe>
                              ) : contenido.url_video.includes('vimeo') ? (
                                // Video de Vimeo
                                <iframe
                                  src={contenido.url_video.replace('/video/', '/embed/')}
                                  title={`Video: ${contenido.descripcion}`}
                                  allow="autoplay; fullscreen; picture-in-picture"
                                  allowFullScreen
                                  style={{border: 'none'}}
                                ></iframe>
                              ) : contenido.url_video.match(/\.(mp4|webm|ogg)$/i) ? (
                                // Video HTML5 directo
                                <video
                                  controls
                                  style={{width: '100%', height: '100%'}}
                                  className="w-100 h-100"
                                  onPlay={() => {
                                    if (!contenido.visto && !contenidosVistos[contenido.clase_contenido_id]) {
                                      //this.marcarContenidoVisto(contenido.clase_contenido_id, clase.materia.ccc)
                                    }
                                  }}
                                >
                                  <source src={contenido.url_video} type="video/mp4" />
                                  Tu navegador no soporta el elemento de video.
                                </video>
                              ) : (
                                // Enlace genérico - mostrar botón para abrir
                                <div className="d-flex flex-column align-items-center justify-content-center h-100 text-white">
                                  <FontAwesomeIcon icon={faPlay} size="3x" className="mb-3" />
                                  <p>Video disponible</p>
                                  <button
                                    className="btn btn-primary mt-2"
                                    onClick={() => this.abrirVideo(contenido.url_video, contenido.clase_contenido_id, clase.materia.ccc)}
                                  >
                                    <FontAwesomeIcon icon={faPlay} className="me-2" />
                                    Reproducir Video
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                          
                          {/* Información adicional del video */}
                          <div className="mt-2">
                            <small className="text-muted">
                              Haz clic en "Ver en Pantalla Completa" para una mejor experiencia de visualización.
                            </small>
                          </div>
                        </div>
                      )}
                      <p className="card-text mb-3 text-muted">{contenido.descripcion_larga}</p>
                      
                      {/* Mostrar documento si existe */}
                      {contenido.archivo && (
                        <div className="mb-3">
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="text-muted mb-0">
                              <FontAwesomeIcon icon={faFilePdf} className="me-2 text-danger" />
                              Documento del Contenido
                            </h6>
                            <div>
                              <button
                                className="btn btn-outline-primary btn-sm me-2"
                                onClick={() => this.abrirDocumento(contenido.archivo, contenido.descripcion, contenido.clase_contenido_id, clase.materia.ccc)}
                              >
                                <FontAwesomeIcon icon={faEye} className="me-1" />
                                Ver
                              </button>
                              <a 
                                href={`${apiImage}${contenido.archivo}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-success btn-sm"
                                download
                              >
                                <FontAwesomeIcon icon={faDownload} className="me-1" />
                                Descargar
                              </a>
                            </div>
                          </div>
                          
                          {/* Iframe para visualización del documento */}
                          <div className="border rounded" style={{height: '400px', overflow: 'hidden'}}>
                            {contenido.archivo.toLowerCase().endsWith('.pdf') ? (
                              <iframe
                                src={`${apiImage}${contenido.archivo}#view=fitH`}
                                title={`Documento: ${contenido.descripcion}`}
                                width="100%"
                                height="100%"
                                style={{border: 'none'}}
                                className="w-100 h-100"
                                onLoad={() => {
                                  // Marcar como visto cuando el documento se carga
                                  if (!contenido.visto && !contenidosVistos[contenido.clase_contenido_id]) {
                                    //this.marcarContenidoVisto(contenido.clase_contenido_id, clase.materia.ccc)
                                  }
                                }}
                              />
                            ) : ['jpg', 'jpeg', 'png', 'gif', 'webp'].some(ext => 
                                contenido.archivo.toLowerCase().endsWith(`.${ext}`)
                              ) ? (
                              <div className="text-center p-2 h-100 d-flex align-items-center justify-content-center">
                                <img 
                                  src={`${apiImage}${contenido.archivo}`}
                                  alt={`Documento: ${contenido.descripcion}`}
                                  style={{maxHeight: '100%', maxWidth: '100%', objectFit: 'contain'}}
                                  className="img-fluid"
                                  onLoad={() => {
                                    // Marcar como visto cuando la imagen se carga
                                    if (!contenido.visto && !contenidosVistos[contenido.clase_contenido_id]) {
                                      //this.marcarContenidoVisto(contenido.clase_contenido_id, clase.materia.ccc)
                                    }
                                  }}
                                />
                              </div>
                            ) : (
                              <div className="text-center p-4 h-100 d-flex flex-column align-items-center justify-content-center">
                                <FontAwesomeIcon icon={faFile} size="3x" className="text-muted mb-2" />
                                <p className="text-muted mb-0">Vista previa no disponible</p>
                                <small className="text-muted">Descarga el archivo para visualizarlo</small>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    )}
                                
                                {/* Evaluaciones */}
                                {clase.evaluaciones.length > 0 && (
                                  <div>
                                    <h6 className="text-primary mb-3">
                                      <FontAwesomeIcon icon={faTasks} className="me-2" />
                                      Evaluaciones
                                    </h6>
                                    <div className="row">
                                      {clase.evaluaciones.map((evaluacion) => (
                                        <div key={evaluacion.id} className="col-md-12 mb-3" id={`evaluacion-${evaluacion.evaluacion}`}>
                                          <div className="card border-warning">
                                            <div className="card-body">
                                              <div className="d-flex align-items-start">
                                                <FontAwesomeIcon 
                                                  icon={faTasks} 
                                                  className="text-warning mt-1 me-3"
                                                  size="lg"
                                                />
                                                <div className="flex-grow-1">
                                                  <h6 className="card-title mb-1">{evaluacion.descripcion}</h6>
                                                  <div className="d-flex justify-content-between align-items-center">
                                                    <span className="badge bg-warning text-dark">
                                                      Evaluación
                                                    </span>
                                                    {evaluacion.nota==null?
                                                    <button
                                                      className="btn btn-primary btn-sm"
                                                      onClick={() => this.VerEvaluacion(
                                                        evaluacion.evaluacion, 
                                                        clase.materia.titulo,
                                                        clase.materia.ccc
                                                      )}
                                                    >
                                                      <FontAwesomeIcon icon={faTasks} className="me-1" />
                                                      Realizar Evaluación
                                                    </button>:evaluacion.nota+' Puntos'} 
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                )}

                                {/* Foros */}
                              {clase.foros && clase.foros.length > 0 && (
  <div>
    <h6 className="text-primary mb-3">
      <FontAwesomeIcon icon={faComments} className="me-2" />
      Foros de Discusión
    </h6>
    <div className="row">
      {clase.foros.map((foro) => (
        <div key={foro.id} className="col-md-12 mb-3" id={`foro-${foro.id}`}>
          <div className="card border-info">
            <div className="card-body">
              <div className="d-flex align-items-start">
                <FontAwesomeIcon 
                  icon={faComments} 
                  className="text-info mt-1 me-3"
                  size="lg"
                />
                <div className="flex-grow-1">
                  <h6 className="card-title mb-1">{foro.nombre}</h6>
                  <p className="card-text mb-3">{foro.descripcion}</p>
                  
                  {/* Visualización del documento del foro */}
                  {foro.documento && (
                    <div className="mb-3">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="text-muted mb-0">
                          <FontAwesomeIcon icon={faFilePdf} className="me-2 text-danger" />
                          Documento del Foro
                        </h6>
                        <a 
                          href={`${apiImage}${foro.documento}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-outline-success btn-sm"
                          download
                        >
                          <FontAwesomeIcon icon={faDownload} className="me-1" />
                          Descargar
                        </a>
                      </div>
                      
                      {/* Iframe para visualización */}
                      <div className="border rounded" style={{height: '300px', overflow: 'hidden'}}>
                        {foro.documento.toLowerCase().endsWith('.pdf') ? (
                          <iframe
                            src={`${apiImage}${foro.documento}#view=fitH`}
                            title={`Documento: ${foro.nombre}`}
                            width="100%"
                            height="100%"
                            style={{border: 'none'}}
                            className="w-100 h-100"
                          />
                        ) : ['jpg', 'jpeg', 'png', 'gif', 'webp'].some(ext => 
                            foro.documento.toLowerCase().endsWith(`.${ext}`)
                          ) ? (
                          <div className="text-center p-2 h-100 d-flex align-items-center justify-content-center">
                            <img 
                              src={`${apiImage}${foro.documento}`}
                              alt={`Documento: ${foro.nombre}`}
                              style={{maxHeight: '100%', maxWidth: '100%', objectFit: 'contain'}}
                              className="img-fluid"
                            />
                          </div>
                        ) : (
                          <div className="text-center p-4 h-100 d-flex flex-column align-items-center justify-content-center">
                            <FontAwesomeIcon icon={faFile} size="3x" className="text-muted mb-2" />
                            <p className="text-muted mb-0">Vista previa no disponible</p>
                            <small className="text-muted">Descarga el archivo para visualizarlo</small>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* SECCIÓN DE COMENTARIOS TIPO FACEBOOK */}
                  <div className="mt-4 border-top pt-3">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h6 className="mb-0 text-muted">
                        <FontAwesomeIcon icon={faComments} className="me-2" />
                        Comentarios ({foro.respuestas?.length || 0})
                      </h6>
                      
                      {/* Botón para abrir modal si hay más funcionalidades */}
                      <button
                        className="btn btn-info btn-sm"
                        onClick={() => this.abrirForo(
                          clase.materia.ccc,
                          clase.materia.titulo
                        )}
                      >
                        <FontAwesomeIcon icon={faComments} className="me-1" />
                        {foro.mi_respuesta ? 'Ver Foro' : 'Participar'}
                      </button>
                    </div>

                    {/* Lista de comentarios/respuestas */}
                    {foro.respuestas && foro.respuestas.length > 0 ? (
                      <div className="comentarios-container">
                        {foro.respuestas.map((respuesta) => (
                          <div 
                            key={respuesta.id} 
                            className={`card mb-2`}
                          >
                            <div className="card-body p-3">
                              <div className="d-flex align-items-start">
                                <div className="flex-grow-1">
                                  <div className="d-flex justify-content-between align-items-start mb-2">
                                    <div>
                                      <h6 className="mb-0">
                                        <FontAwesomeIcon 
                                          icon={faUser} 
                                          className={`me-2 ${respuesta.es_mi_respuesta ? 'text-primary' : 'text-muted'}`}
                                        />
                                        {respuesta.estudiante_nombre}
                                        {respuesta.es_mi_respuesta && (
                                          <span className="badge bg-primary ms-2">Tú</span>
                                        )}
                                      </h6>
                                      <small className="text-muted">
                                        <FontAwesomeIcon icon={faClock} className="me-1" />
                                        {new Date(respuesta.fecha_respusta).toLocaleString()}
                                      </small>
                                    </div>
                                    
                                    {/* Calificación */}
                                    {respuesta.calificacion && (
                                      <span className="badge bg-success">
                                        {respuesta.calificacion} pts
                                      </span>
                                    )}
                                  </div>
                                  
                                  <p className="mb-2">{respuesta.comentario}</p>
                                  
                                  {/* Documento adjunto de la respuesta */}
                                  {respuesta.documento_adjunto && (
                                    
                                    <div className="border rounded" style={{height: '200px', overflow: 'hidden'}}>
                                                                                    {respuesta.documento_adjunto.toLowerCase().endsWith('.pdf') ? (
                                                                                      <iframe
                                                                                        src={`${apiImage}${respuesta.documento_adjunto}#view=fitH`}
                                                                                        title={`Documento:`}
                                                                                        width="100%"
                                                                                        height="100%"
                                                                                        style={{border: 'none'}}
                                                                                        className="w-100 h-100"
                                                                                      />
                                                                                    ) : ['jpg', 'jpeg', 'png', 'gif', 'webp'].some(ext => 
                                                                                       respuesta.documento_adjunto.toLowerCase().endsWith(`.${ext}`)
                                                                                      ) ? (
                                                                                      <div className="text-center p-2 h-100 d-flex align-items-center justify-content-center">
                                                                                        <img 
                                                                                          src={`${apiImage}${respuesta.documento_adjunto}`}
                                                                                          alt={`Documento:`}
                                                                                          style={{maxHeight: '100%', maxWidth: '100%', objectFit: 'contain'}}
                                                                                          className="img-fluid"
                                                                                        />
                                                                                      </div>
                                                                                    ) : (
                                                                                      <div className="text-center p-4 h-100 d-flex flex-column align-items-center justify-content-center">
                                                                                        <FontAwesomeIcon icon={faFile} size="3x" className="text-muted mb-2" />
                                                                                        <p className="text-muted mb-0">Vista previa no disponible</p>
                                                                                        <small className="text-muted">Descarga el archivo para visualizarlo</small>
                                                                                      </div>
                                                                                    )}
                                                              </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="text-center text-muted py-3">
                        <FontAwesomeIcon icon={faComments} size="2x" className="mb-2" />
                        <p>No hay comentarios aún</p>
                        <small>Sé el primero en comentar</small>
                      </div>
                    )}

                    {/* Información de participación del usuario */}
                    <div className="mt-3">
                      {foro.mi_respuesta ? (
                        <div className="alert alert-success py-2">
                          <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                          <small>
                            <strong>Ya participaste en este foro</strong>
                            {foro.calificacion_mi_respuesta && (
                              <span className="ms-2">| Calificación: {foro.calificacion_mi_respuesta}</span>
                            )}
                          </small>
                        </div>
                      ) : (
                        <div className="alert alert-warning py-2">
                          <FontAwesomeIcon icon={faInfo} className="me-2" />
                          <small>
                            <strong>No has participado aún</strong>
                            <span className="ms-2">| Fecha límite: {new Date(foro.fecha_final).toLocaleDateString()}</span>
                          </small>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
)}
                                
                                {clase.contenidos.length === 0 && clase.evaluaciones.length === 0 && (!clase.foros || clase.foros.length === 0) && (
                                  <div className="text-center text-muted py-4">
                                    <FontAwesomeIcon icon={faBook} size="2x" className="mb-2" />
                                    <p>No hay contenido disponible para esta clase</p>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                    
                    {clasesCurso.length === 0 && (
                      <div className="text-center text-muted py-5">
                        <FontAwesomeIcon icon={faBook} size="3x" className="mb-3" />
                        <h5>No hay clases disponibles para este curso</h5>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default Listar